// extracted by mini-css-extract-plugin
export default {"widthColumn1Trigger":"1125px"};